import React from 'react';
import { Nav } from '@themesberg/react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { Routes } from '../routes';

/** Shared top nav for authenticated admin pages. */
export default function AdminNav() {
  const { pathname } = useLocation();

  const Item = ({ to, label }) => (
    <Nav.Item>
      <Nav.Link as={Link} to={to} active={pathname === to} className="px-2">
        {label}
      </Nav.Link>
    </Nav.Item>
  );

  return (
    <Nav variant="pills" className="mb-3 flex-row gap-1">
      <Item to={Routes.AdminTenants.path} label="Tenants" />
      <Item to={Routes.AdminOperators.path} label="Operators" />
      <Item to={Routes.AdminAccount.path} label="Account" />
    </Nav>
  );
}
